export enum ButtonTypes {
  Primary = 'primary',
  OutlinePrimary = 'outline-primary'
}
